import { action, props } from 'ts-action';
import { ClusterBeat } from '../clustering/clustering.types';

export const select = action(
  '[Beats] selectBeats',
  props<{ ids: Set<number> }>(),
);

export const cleanUp = action('[Beats] cleanUp');

export const load = action('[Beats] load', props<{ beats: ClusterBeat[] }>());

export const togglePinnedBeat = action(
  '[Beats] togglePinnedBeat',
  props<{ id?: number }>(),
);

export const toggleHoveredBeat = action(
  '[Beats] toggleHoveredBeat',
  props<{ id?: number }>(),
);
